export default "__VITE_ASSET__CHYnf3Qh__"